import { makeBetterEnum } from './betterEnum';

export const FilterConjunction = makeBetterEnum('andConjunction');

export type FilterConjunction =
  (typeof FilterConjunction)[keyof typeof FilterConjunction];

export const FilterOperator = makeBetterEnum('in', 'notIn');

export type FilterOperator =
  (typeof FilterOperator)[keyof typeof FilterOperator];
